import React from 'react';

import { WithTranslation, withTranslation } from 'react-i18next';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Rest } from '../../utils/utils';
import { URL } from '../../utils/rest';
import SignPrescriptionResponseOtp from './operations/signPrescriptionResponseOtp';
import SignOtpModalContainer, { OtpCallerProps } from './signOtpModalContainer';
import SignSuccessModal from './signSuccessModal';
import SignPrescriptionContainer from './signPrescriptionContainer';
import SignPrescriptionResult from './entities/signPrescriptionResult';
import SignMultipleSignModal from './signMultipleSignModal';
import AutofirmaWebsocketManager from './AutofirmaWebsocketManager';
import { notification } from 'antd';

interface IProps {
    visible?: boolean;
    idPrescripcionGrupo: number;
    idPaciente?: number;
    emailPaciente?: string;
    onClose: () => void;
}

export interface IState extends OtpCallerProps {
    errorMessage?: string;
    warningMessage?: string;
    errorFields?: string[];
    codeResult?: number;
    signSuccessVisible?: boolean;
    signSuccessKey?: number;
    signPrescriptionVisible?: boolean;
    signPrescriptionKey?: number;
    emailPatient?: string;
    multipleSignModalVisible?: boolean;
    multipleSignModalKey?: number;
    firmaMultipleEnProceso?: boolean;
}

class LocalSaveSingContainer extends React.Component<IProps & WithTranslation & RouteComponentProps, IState> {

    public state: IState = {firmaMultipleEnProceso: false};
    private autoFirmaIframe: HTMLIFrameElement | null = null;
    private autoFirmaManager: AutofirmaWebsocketManager | null = null;
    private autoFirmaInterval: number | null = null;

    public componentDidMount() {

        if (this.props.visible) {
            this.startSigningProcess();
        }
    }

    public render() {

        return (
            <>
                <SignOtpModalContainer
                    otpType={this.state.otpType}
                    valueUuId={this.state.valueUuId!}
                    email={this.state.email}
                    dispositivo={this.state.dispositivoMovil}
                    key={this.state.signOTPkey}
                    visible={this.state.signOtpVisible}
                    oncloseSignOTP={this.oncloseSignOTP}
                    tryAgain={this.startSigningProcess}
                    sendByEmail={() => this.onCreateValidateOtp(true)}
                    onValidationSuccess={this.onValidOtp}
                />
                <SignPrescriptionContainer
                    key={this.state.signPrescriptionKey}
                    visible={this.state.signPrescriptionVisible}
                    onCreateValidateOtp={this.onCreateValidateOtp}
                    onAutofirmaSignature={this.onAutofirmaSignature}
                    onClose={this.onCloseSignPrescription}
                    onSuccess={this.onSuccess}
                />
                <SignSuccessModal
                    key={this.state.signSuccessKey}
                    visible={this.state.signSuccessVisible}
                    emailPatient={this.state.emailPatient}
                    onClose={this.onCloseSignSuccess}
                    hipDownload={this.hipDownload}
                    sendEmailHip={this.sendEmailHip}
                />

                <SignMultipleSignModal
                    key={this.state.multipleSignModalKey}
                    visible={this.state.multipleSignModalVisible}
                    onClose={this.onCloseMultipleSignsModal}
                />
            </>
        );
    }

    private sendEmailHip = (email: string) => {
        Rest<{type: string, idPaciente: number, idPrescripcionGrupo:number, saveEmail: boolean, newEmail?: string}, any>().operation({
            type: 'ResendDocumentoHipToUser',
            idPaciente: this.props.idPaciente!,
            idPrescripcionGrupo: this.props.idPrescripcionGrupo,
            saveEmail: true,
            newEmail: email
        }).then(response => {
            this.onCloseSignSuccess();
        });
    }

    private onCloseSignPrescription = () => {
        this.setState({signPrescriptionVisible: false, firmaMultipleEnProceso: false}, () => this.cleanAutoFirmaResources());
        
    }

    private oncloseSignOTP = () => {
        this.setState({ signOtpVisible: false });
    }

    private onCreateValidateOtp = (sendByEmail?: boolean) => {
        this.cleanAutoFirmaResources();
        Rest<{type: string, idPrescripcionGrupo: number, useEmail?: boolean, procesoFirmaIniciado?:boolean}, SignPrescriptionResponseOtp>().operation(
            { type: 'CreateOtpForSignature',
              idPrescripcionGrupo: this.props.idPrescripcionGrupo,
              useEmail: sendByEmail})
            .then(response => {
                if (!response.otpNeeded) {
                    this.onSignPrescription(undefined, undefined);
                } else {
                    this.setState({
                        otpType: response.otpType,
                        valueUuId: response.valueUuId,
                        email: response.email,
                        dispositivoMovil: response.dispositivoMovil,
                        errorMessage: undefined,
                        warningMessage: undefined,
                        signOtpVisible: true,
                        signOTPkey: new Date().getTime(),
                        signPrescriptionVisible: false
                    });
                }
            });        
    }

    private onValidOtp = (valueUuId: string, otp?: string) => {
        this.setState({
            signOtpVisible: false
        }, () => this.onSignPrescription(valueUuId, otp));        
    }

    private onSignPrescription = (valueUuId?: string, otp?: string) => {
        Rest<{ type: string, valueUuId?: string,  otp?: string}, SignPrescriptionResult>().operation({
            type: 'SignPrescription',
            valueUuId : valueUuId,
            otp: otp,
        }).then(response => {
            if(response.lastPrescriptions){
                this.onSuccess(response);
            }else{
                this.setState({signPrescriptionVisible: false},() => this.startSigningProcess())
            }
            
        })
        /*.catch(error => {
            notification['error']({ 
                message: this.props.t('genericErrorSign'),
                duration : 20
            });            
        });*/
    }    

    private onCloseSignSuccess = () => {
        this.setState({
            signSuccessVisible: false
        }, () => this.props.onClose());
    }

    private hipDownload = () => {
        const file_path = URL + '/file?ddp' +
            (this.props.idPrescripcionGrupo ? '&idPrescripcionGrupo=' + this.props.idPrescripcionGrupo : '');
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.href = file_path;
        a.click();
        document.body.removeChild(a);

        this.onCloseSignSuccess();
    }

    private startSigningProcess = () => {
        Rest<{ type: string, idPrescripcionGrupo: number, firmaMultipleEnProceso?: boolean}, boolean>().operation({
            type: 'StartLocalSigningProcess',
            idPrescripcionGrupo: this.props.idPrescripcionGrupo!,
            firmaMultipleEnProceso: this.state.firmaMultipleEnProceso
        }).then(response => {
            if (response == true) {
                this.setState({
                    signOtpVisible: false,
                    firmaMultipleEnProceso: true,
                    multipleSignModalVisible: true,
                    multipleSignModalKey: new Date().getTime()
                });
            } else {
                this.setState({
                    signOtpVisible: false,
                    signPrescriptionVisible: true,
                    signPrescriptionKey: new Date().getTime()
                });
            }
        });        
    }

    private onCloseMultipleSignsModal = () =>{
        this.setState({
            signOtpVisible: false,
            multipleSignModalVisible: false,
            signPrescriptionVisible: true,
            signPrescriptionKey: new Date().getTime()
        });
    }

    private onSuccess = (resultSign: SignPrescriptionResult) => {
        this.setState({
            signPrescriptionVisible: false,
            signSuccessVisible: true,
            signSuccessKey: new Date().getTime(),
            emailPatient: resultSign.emailPatient ? resultSign.emailPatient : this.props.emailPaciente
        });
    }

    private onAutofirmaSignature = () => {

        this.cleanAutoFirmaResources();

        this.autoFirmaIframe = document.createElement('iframe');
        this.autoFirmaIframe.onload = () => {
            console.log('Autofirma abierto?');
        }
        this.autoFirmaIframe.src = 'afirma://websocket?v=3&jvc=2&mcv=1.7.0';
        document.body.appendChild(this.autoFirmaIframe);

        this.autoFirmaInterval = window.setInterval(() =>  {
            this.autoFirmaManager = new AutofirmaWebsocketManager(() => {
                this.autoFirmaIframe?.parentElement?.removeChild(this.autoFirmaIframe);
                window.clearInterval(this.autoFirmaInterval!);

                fetch(URL + '/file?fdp&b64')
                .then(response => response.json())
                .then(result => {
                    const autoFirmaMessage = "afirma://sign?op=sign&cop=sign&algorithm=SHA512withRSA&format=PAdES&sticky=false&dat=";
                    this.autoFirmaManager?.sendMessage(autoFirmaMessage + result.fileb64);
                });
            }, (data) => {

                    Rest<{ type: string, data: string}, SignPrescriptionResult>().operation({
                        type: 'ProcessAutoFirmaSignature',
                        data : data,
                    }).then(response => {
                        this.cleanAutoFirmaResources();
                        if (!response.valid) {
                            notification['error']({ 
                                message: (this.props.t('errorFirmaCertificado')),
                                duration: 20
                            });
                        } else if (response.lastPrescriptions) {
                            this.onSuccess(response);
                        } else {
                            this.setState({signPrescriptionVisible: false},() => this.startSigningProcess())
                        }
                    })
                });
        }, 2000);
    }

    private cleanAutoFirmaResources = () => {
        if (this.autoFirmaIframe) {
            this.autoFirmaIframe.parentElement?.removeChild(this.autoFirmaIframe);
        }

        if (this.autoFirmaInterval) {
            window.clearInterval(this.autoFirmaInterval);
            this.autoFirmaInterval = null;
        }

        if (this.autoFirmaManager) {
            this.autoFirmaManager.close();
        }
    }

}

export default withTranslation('signPrescripction')(withRouter(LocalSaveSingContainer));